import { render, staticRenderFns } from "./Inners.vue?vue&type=template&id=61c3f0f2&"
import script from "./Inners.vue?vue&type=script&lang=js&"
export * from "./Inners.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports